import React, { useState, useEffect, Fragment } from 'react';
import sanityClient from '../client';

const getRandomItem = (arr) => {
  const randomIndex = Math.floor(Math.random() * arr.length);
  return arr[randomIndex];
};

const RandomItem = (data) => {
  const item = getRandomItem(data.data);
  return (
    <Fragment>
      <div className='container max-w-lg px-4 py-32 mx-auto text-left md:max-w-none md:text-center'>
        <h1 className='text-5xl font-extrabold leading-10 tracking-tight text-left text-gray-900 md:text-center sm:leading-none md:text-6xl lg:text-7xl'>
          <span className='inline md:block'>{item.text}</span>
          <br />
          <span className='relative mt-2 text-transparent bg-clip-text bg-gradient-to-br from-gray-500 to-gray-400'>
            {item.author.name}
          </span>
        </h1>
      </div>
    </Fragment>
  );
};

const Landing = (props) => {
  const [allData, setAllData] = useState([]);
  useEffect(() => {
    let result;
    const cachedResult = JSON.parse(localStorage.getItem('words'));
    if (cachedResult) {
      result = cachedResult;
    } else {
      sanityClient
        .fetch(`*[_type == 'quote']{...,author->}{text,author{name}}`)
        .then((data) => {
          localStorage.setItem('words', JSON.stringify(data));
          result = data;
        })
        .catch(console.error);
    }
    setAllData(result);
  }, []);
  if (typeof allData == 'undefined') {
    window.location.reload();
  }
  return allData && allData.length > 0 ? (
    <div>
      <RandomItem data={allData}></RandomItem>
    </div>
  ) : (
    <Fragment></Fragment>
  );
};

Landing.propTypes = {};

export default Landing;
